<template>
  <div class="pa-4">
    <div class="text-xs-right pb-4">
      <v-btn @click="$emit('close')" icon outline>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="dataCoupon"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.ref_receipt || '-' }}</td>
          <td>{{ props.item.ref_no || '-' }}</td>
          <td>{{ props.item.store_id || '-' }}</td>
          <td>
            {{ props.item.ref_date ? moment(props.item.ref_date).format('DD/MM/YYYY') : '-' }}
          </td>
          <td>{{ props.item.status | statusWording }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  data() {
    return {
      headers: [
        { text: 'เลขที่ใบเสร็จ', value: 'ref_receipt' },
        { text: 'Ref.', value: 'ref_no' },
        { text: 'รหัสร้านค้า', value: 'store_id' },
        { text: 'วันที่ในเอกสาร', value: 'ref_date' },
        { text: 'สถานะ', value: 'status' }
      ],
      offset: 0,
      limit: 10,
      dataCoupon: [],
      loading: false
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    }
  },
  methods: {
    getData() {
      let data = {
        pageid: this.selectedBot.pageid,
        userid: this.id,
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true
      api.getMemberReceiptsToaecoupon(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.dataCoupon = response.data
        }
      })
    }
  },
  filters: {
    statusWording(val) {
      let master = [
        { value: 'approved', text: 'อนุมัติ' },
        { value: 'reject', text: 'ไม่อนุมัติ' },
        { value: 'pending', text: 'รอการอนุมัติ' },
        { value: 'waiting_for_delivery', text: 'รอจัดส่ง' }
      ]
      return master.find((f) => f.value == val).text
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/MemberHistoryCoupon.vue